import styled, { css } from 'styled-components';
import media from '../../constants/media';
import * as StyledRadioTile from '../base/forms/formikRadioTile/formikRadioTile.styles';
import { inputStyles } from '../base/forms/input';
import { Label } from '../base/forms/label';
import { Column, Columns } from '../base/grid';

export const Wrapper = styled.div`
	/* Removes arrows from number input */
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type='number'] {
		-moz-appearance: textfield;
	}
`;

export const InputStyles = styled.input`
	${inputStyles}
	text-align: right;
	-webkit-outer-spin-button,
	-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

export const RadioWrapper = styled(StyledRadioTile.Wrapper)``;

export const RadioTileLabelWithIcon = styled(StyledRadioTile.RadioTileLabel)`
	position: relative;
	p {
		font-size: 1.8rem;
		margin: auto;
		padding-left: 2rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	svg {
		position: absolute;
		left: 2rem;
		top: 28%;
	}
	${media.tablet`
		padding: 4rem 2rem 4rem 8rem;
	`}

	${media.mobileOnly`
		padding-left: 10rem;
	`}
`;

export const RadioTileLabel = styled(StyledRadioTile.RadioTileLabel)`
	text-align: center;
	${media.tablet`
		padding: 4rem 0;
	`}

	p {
		font-size: 1.8rem;
		margin: auto;
	}
`;

export const SelectWrapper = styled.div`
	font-size: 2rem;
	${media.tablet`
        font-size: 1.7rem;
    `};
`;

export const InfoText = styled.div`
	font-size: 1.6rem;
	margin-bottom: 0.5rem;
`;

export const PaddingLabel = styled(Label)`
	padding-top: 1rem;
`;

export const SendingFeePrice = styled.div`
	color: ${({ theme }) => theme.colors.primary};
	position: absolute;
	right: 4rem;
	bottom: 1rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
`;

export const ExpenseWrapper = styled.div`
	border-top: 1px solid;
	border-bottom: 1px solid;
	border-color: ${({ theme }) => theme.colors.gray};
	margin-bottom: 1.5rem;
`;

export const Expense = styled.div`
	padding: 1rem;
	font-size: 1.7rem;
	${({ right }) =>
		right &&
		css`
			text-align: right;
		`}

	${({ secondary }) =>
		secondary &&
		css`
			color: ${({ theme }) => theme.colors.secondary};
		`}

    ${({ primary }) =>
		primary &&
		css`
			color: ${({ theme }) => theme.colors.primary};
		`}

	${({ strong }) =>
		strong &&
		css`
			letter-spacing: 0.7px;
			line-height: 24px;
			font-size: 2rem;
		`}
`;

export const BorderColumns = styled(Columns)`
	margin: 0;
	border-bottom: 1px solid;
	border-color: ${({ theme }) => theme.colors.grayLight};
	${({ big }) =>
		big &&
		css`
			padding: 0.5rem 0;
		`}
`;

export const TextColumn = styled(Column)`
	margin-bottom: 0;
`;

export const Ref = styled.span`
	color: ${({ theme }) => theme.colors.primary};
	font-size: 2rem;
`;
